/**
 * University Reviews Data
 * Expert testimonials from university researchers
 */
const assetsUrl = `${window.template_root}/src/public/`;

export const universityReviews = [
  {
    id: "1",
    quote:
      "These beneficial microbes help maintain healthy bowel function, and may even help with conditions like inflammatory bowel disease. Research suggests they may even play a role in regulating weight and mood.",
    name: "Dr. James Wilson, MD",
    title: "Professor of Gastroenterology",
    university: "Harvard Medical School",
    avatar: "img/wilson.webp",
    logo: `${assetsUrl}img/logos/harvard.svg`,
  },
  {
    id: "2",
    quote:
      "Resistant starch is a prebiotic fibre that is fermented by the gut microbiota and leads to benefits for host physiology. A clinical trial demonstrates weight loss when resistant starch was given to individuals with excess weight.",
    name: "Dr. Emily Chen, PhD",
    title: "Nature Metabolism",
    university: "Stanford University",
    avatar: "img/chen.webp",
    logo: `${assetsUrl}img/logos/stanford.svg`,
  },
  {
    id: "3",
    quote:
      "Gut microbiota has been implicated in regulation of fat storage, as well as gut dysbiosis, thus contributing to the development of obesity, insulin resistance, hyperglycemia and hyperlipidemia.",
    name: "Dr. Sarah Johnson, PhD",
    title: "The Obesity Society",
    university: "Western University",
    avatar: "img/johnson.webp",
    logo: `${assetsUrl}img/logos/western.svg`,
  },
  {
    id: "4",
    quote:
      "Probiotics can help replenish or modulate gut microbial communities after disturbances such as stress, illness, or antibiotic therapy, and by altering microbial function—have the potential to influence digestion and metabolic processes.",
    name: "Dr. Michael Brown, MD",
    title: "Therapeutic Advances in Gastroenterology",
    university: "Baylor College of Medicine",
    avatar: "img/brown.webp",
    logo: `${assetsUrl}img/logos/bmc.svg`,
  },
];

export default universityReviews;
